import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  EnvironmentProviders,
  Provider,
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FuseConfig } from '@library/services/config';
import { FUSE_CONFIG } from '@library/services/config/config.constants';
import { FuseConfirmationService } from '@library/services/confirmation';
import { FuseLoadingService, fuseLoadingInterceptor } from '@library/services/loading';
import { FuseMediaWatcherService } from '@library/services/media-watcher';
import { FusePlatformService } from '@library/services/platform';
import { FuseSplashScreenService } from '@library/services/splash-screen';
import { FuseUtilsService } from '@library/services/utils';

export type FuseProviderConfig = {
  mockApi?: {
    delay?: number;
    service?: any;
  };
  fuse?: FuseConfig;
};

/**
 * Fuse provider
 */
export const provideFuse = (config: FuseProviderConfig): Array<Provider | EnvironmentProviders> => {
  // Base providers
  const providers: Array<Provider | EnvironmentProviders> = [
    // Angular Material 21 elimino los sanity checks (MATERIAL_SANITY_CHECKS), asi que
    // ya no hay nada que desactivar: el aviso de 'theme' que silenciabamos no existe.
    {
      // Use the 'fill' appearance on Angular Material form fields by default
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'fill',
      },
    },
    {
      provide: FUSE_CONFIG,
      useValue: config?.fuse ?? {},
    },

    importProvidersFrom(MatDialogModule),
    provideEnvironmentInitializer(() => inject(FuseConfirmationService)),

    provideHttpClient(withInterceptors([fuseLoadingInterceptor])),
    provideEnvironmentInitializer(() => inject(FuseLoadingService)),

    provideEnvironmentInitializer(() => inject(FuseMediaWatcherService)),
    provideEnvironmentInitializer(() => inject(FusePlatformService)),
    provideEnvironmentInitializer(() => inject(FuseSplashScreenService)),
    provideEnvironmentInitializer(() => inject(FuseUtilsService)),
  ];

  // Return the providers
  return providers;
};
